/**
 * Creates a linear scale function that maps values from a domain to a range
 *
 * @param {number} domainMin - Minimum word weight in the domain
 * @param {number} domainMax - Maximum word weight in the domain
 * @param {number} rangeMin - Minimum font size in the range
 * @param {number} rangeMax - Maximum font size in the range
 * @param {number} sameWeightValue - Font size to use if all words have the same weight
 * @returns {Function} A function that maps a value from the domain to the range
 */
export const makeLinearScale = (domainMin, domainMax, rangeMin, rangeMax, sameWeightValue) => {
  if (domainMax === domainMin) {
    return () => sameWeightValue;
  }

  const span = domainMax - domainMin; // denominator once, reuse each call

  return (value) => {
    const pct = (value - domainMin) / span; // 0 → 1 relative position
    const clamped = Math.min(Math.max(pct, 0), 1);

    return Math.round(rangeMin + clamped * (rangeMax - rangeMin));
  };
};
